module.exports = __webpack_public_path__ + "static/media/olake-github.5633ee33.svg";